import { Clock } from "lucide-react";
import React from "react";

const TimePeriodPill = ({ duration }) => {
  const days = duration?.days;
  const hours = duration?.hours;
  const minutes = duration?.minutes;
  return (
    <div className="border border-gray-200 dark:border-gray-800 rounded-lg bg-white dark:bg-gray-900 p-2 flex items-center gap-1 z-10">
      <Clock className="text-green-500 w-4 h-4" />
      <p className="text-xs text-gray-800 dark:text-gray-200 flex items-center gap-1">
        <span className="text-green-500 text-sm font-bold">
          {days || hours || minutes || 0}
        </span>
        {days ? "Day" : hours ? "Hour" : minutes ? "Minute" : ""}
        {days && days > 1
          ? "s"
          : hours && hours > 1
            ? "s"
            : minutes && minutes > 1
              ? "s"
              : ""}
      </p>
    </div>
  );
};

export default TimePeriodPill;
